import React, { FunctionComponent, useEffect } from 'react';
import { IImage } from '../../../../../../common/model/ICarDetails';
import sliderImageStyles from './SliderImageStyles';
import { Box } from '@material-ui/core';
import Image from 'material-ui-image';
import { ImageType } from '../../../../../../../../common/enum/ImageType';
import useIsMobile from '../../../../../../common/react/useIsMobile';
import useIsTablet from '../../../../../../common/react/useIsTablet';

interface ISliderImage {
  image?: IImage;
  index?: number;
  defaultSrc?: string;
  alt?: string;
  setIsInteriorImageDisplay?: (isInteriorImage: boolean) => void;
}

const SliderImage: FunctionComponent<ISliderImage> = ({ alt, image, index, defaultSrc, setIsInteriorImageDisplay }) => {
  const styles = sliderImageStyles();
  const isInteriorImage = image?.type === ImageType.INTERIOR;
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  const interiorImageAspectRatio = isMobile ? 1.1 : isTablet ? 1.5 : 1.8;
  const exteriorImageAspectRatio = isTablet ? 2.5 : 2.9;

  useEffect(() => {
    if (setIsInteriorImageDisplay) {
      setIsInteriorImageDisplay(isInteriorImage);
    }
  }, [isInteriorImage]);

  return (
    <Box className={styles.container}>
      <Image
        src={image?.url || defaultSrc}
        color="transparent"
        animationDuration={0}
        aspectRatio={isInteriorImage ? interiorImageAspectRatio : exteriorImageAspectRatio}
        data-test={`image:variant:${image ? index : 'unavailable'}`}
        alt={`${alt} ${image?.type}`}
        className={isInteriorImage ? styles.interiorImage : styles.image}
      />
    </Box>
  );
};

export default SliderImage;
